var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pwa_set" },
    [
      _c("b-overlay", { attrs: { show: _vm.is_load } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-12 col-xl-12" },
            [
              _c("div", { staticClass: "templ_skin" }, [
                _c("div", { staticClass: "pr-3 py-3" }, [
                  _c(
                    "div",
                    { staticClass: "row no-gutters" },
                    _vm._l(_vm.template_skins, function (template) {
                      return _c(
                        "div",
                        { staticClass: "col-4 pr-2 text-center" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex bg-white border rounded overflow-hidden text-success js-waves-on waves-effect waves-themed",
                              class: { is_active: template.is_active },
                              staticStyle: { height: "80px" },
                              attrs: {
                                id: template.id,
                                class: template.inside_class.add_class,
                                "data-placement": "top",
                                "data-replaceclass": "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.set_skin(template)
                                },
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "px-2 pt-0 border-right",
                                class: template.inside_class.left_class,
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column flex-1" },
                                [
                                  _c("div", {
                                    staticClass: "border-bottom py-1",
                                    class: template.inside_class.level1,
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "flex-1 pt-3 pb-3 px-2",
                                    class: template.inside_class.level2,
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n                                " +
                              _vm._s(template.name) +
                              "\n                            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters mt-3" }, [
                _c("div", { staticClass: "col-4 px-1 text-center" }, [
                  _c(
                    "div",
                    { staticClass: "color_choise" },
                    [
                      _c("div", { staticClass: "title bold fs-xl mb-2" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.__t("BG_PRIMARY")) +
                            "\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("compact-picker", {
                        attrs: {
                          "disable-fields": false,
                          type: "hex",
                          "disable-alpha": true,
                        },
                        model: {
                          value: _vm.primary_color,
                          callback: function ($$v) {
                            _vm.primary_color = $$v
                          },
                          expression: "primary_color",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 px-1 text-center" }, [
                  _c(
                    "div",
                    { staticClass: "color_choise" },
                    [
                      _c("div", { staticClass: "title bold fs-xl mb-2" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.__t("BG_SEC")) +
                            "\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("compact-picker", {
                        attrs: {
                          "disable-fields": false,
                          type: "hex",
                          "disable-alpha": true,
                        },
                        model: {
                          value: _vm.secondary_color,
                          callback: function ($$v) {
                            _vm.secondary_color = $$v
                          },
                          expression: "secondary_color",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "next_step text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-lg mt-3 mb-3 imc_succ ml-5",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.reset.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "fal fal fa-check mr-1" }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t("RESET")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }